import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const HeartFillIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M7.76475 3.75C5.01271 3.75 2.75 5.97254 2.75 8.73948C2.75 10.3807 3.24007 11.7071 4.54619 13.2732C5.82112 14.8019 7.90076 16.5913 11.0971 19.1809L11.75 19.75L12.4029 19.1809C15.5992 16.5913 17.6789 14.8019 18.9538 13.2732C20.2599 11.7071 20.75 10.3807 20.75 8.73948C20.75 6.01357 18.5285 3.75 15.7352 3.75C13.8029 3.75 12.57 4.68058 11.75 5.51556C10.93 4.68058 9.69714 3.75 7.76475 3.75Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
